import type { OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { isNullOrUndefined } from 'is-what';
import { StringConstants } from '../../rcr-exchange/constants/string-constants';
import { UserService } from '../../shared/services/user.service';
import { DisclosureAnalyticsService } from '../services/disclosure-analytics.service';
import { PassDataService } from '../services/pass-data.service';

@Component({
  standalone: false,
  selector: 'invd-collateral-analyzer-details',
  templateUrl: './collateral-analyzer-details.component.html',
  styleUrls: ['./collateral-analyzer-details.component.scss'],
})
export class CollateralAnalyzerDetailsComponent implements OnInit {
  private passDataService = inject(PassDataService);
  private userService = inject(UserService);
  private disclosureAnalyticsService = inject(DisclosureAnalyticsService);
  private cdr = inject(ChangeDetectorRef);

  @Input() disclosureWaDetailsRes: any;
  @Input() disclosureSellerDetailsRes: any;
  @Input() WAMonthsToMaturity: string;
  @Input() netInterestRate: number;

  public avgCurrentLoanSize: any;
  public avgMortgageLoanAmount: any;
  public currentSecurityUPB: any;
  public eligibleForResecuritization: any;
  public interestOnlySecurityIndicator: any;
  public loanCount: any;
  public longestMaturityDate: any;
  public maxLoanSize: any;
  public paymentDelayDays: any;
  public queryExecTime: any;
  public sellerName: any;
  public servicerName: any;
  public thirdPartyOriginationUPBPercent: any;
  public waBorrowerCreditScore: any;
  public waCombinedLTV: any;
  public waInterestRate: any;
  public waLoanAge: any;
  public waLoanToValue: any;
  public waMortgageLoanAmount: any;
  public waNetInterestRate: any;
  public waOriginalLoanTerm: any;
  public waRemainingMonthsToMaturity: any;

  public avgCurrentLoanSizeError = false;
  public avgMortgageLoanAmountError = false;
  public currentSecurityUPBError = false;
  public eligibleForResecuritizationError = false;
  public interestOnlySecurityIndicatorError = false;
  public loanCountError = false;
  public longestMaturityDateError = false;
  public maxLoanSizeError = false;
  public paymentDelayDaysError = false;
  public queryExecTimeError = false;
  public sellerNameError = false;
  public servicerNameError = false;
  public thirdPartyOriginationUPBPercentError = false;
  public waBorrowerCreditScoreError = false;
  public waCombinedLTVError = false;
  public waInterestRateError = false;
  public waLoanAgeError = false;
  public waLoanToValueError = false;
  public waMortgageLoanAmountError = false;
  public waNetInterestRateError = false;
  public waOriginalLoanTermError = false;
  public waRemainingMonthsToMaturityError = false;

  public showErrorBanner = false;
  public showBannerErrorMsg = '';

  public preliminaryDisclosureText: string = StringConstants.ANALYZER_PRELIMINARY_DISCLOSURE_TEXT;

  ngOnInit() {
    this.checkAnalytics();
    this.resetDetailsAttributes();
    this.showBannerErrorMsg = '';

    this.preliminaryDisclosureText = StringConstants.ANALYZER_PRELIMINARY_DISCLOSURE_TEXT;

    if (this.passDataService.getGoBackEditFlag() === 'true') {
      const waDetails = this.passDataService.getDisclosureWaDetailsRes();
      const sellerDetails = this.passDataService.getDisclosureSellerDetailsRes();
      this.disclosureSelleDetails(sellerDetails);
      this.disclosureWaDetails(waDetails);
    } else {
      this.avgCurrentLoanSize = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.avgCurrentLoanSize)
          ? this.disclosureSellerDetailsRes.avgCurrentLoanSize
          : '-'
        : 'null';
      this.avgMortgageLoanAmount = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.avgMortgageLoanAmount)
          ? this.disclosureSellerDetailsRes.avgMortgageLoanAmount
          : '-'
        : 'null';
      this.currentSecurityUPB = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.currentSecurityUPB)
          ? this.disclosureSellerDetailsRes.currentSecurityUPB
          : '-'
        : 'null';
      this.eligibleForResecuritization = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? this.disclosureSellerDetailsRes.eligibleForResecuritization !== 'null'
          ? this.disclosureSellerDetailsRes.eligibleForResecuritization
          : '-'
        : 'null';
      this.interestOnlySecurityIndicator = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.interestOnlySecurityIndicator)
          ? this.disclosureSellerDetailsRes.interestOnlySecurityIndicator
          : '-'
        : 'null';
      this.longestMaturityDate = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.longestMaturityDate)
          ? this.disclosureSellerDetailsRes.longestMaturityDate
          : '-'
        : 'null';
      this.maxLoanSize = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.maxLoanSize)
          ? this.disclosureSellerDetailsRes.maxLoanSize
          : '-'
        : 'null';
      this.paymentDelayDays = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.paymentDelayDays)
          ? this.disclosureSellerDetailsRes.paymentDelayDays
          : '-'
        : 'null';
      this.queryExecTime = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.queryExecTime)
          ? this.disclosureSellerDetailsRes.queryExecTime
          : '-'
        : 'null';
      this.sellerName = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? this.disclosureSellerDetailsRes.sellerName !== 'null'
          ? this.disclosureSellerDetailsRes.sellerName
          : '-'
        : 'null';
      this.servicerName = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? this.disclosureSellerDetailsRes.servicerName !== 'null'
          ? this.disclosureSellerDetailsRes.servicerName
          : '-'
        : 'null';
      this.thirdPartyOriginationUPBPercent = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.thirdPartyOriginationUPBPercent)
          ? this.disclosureSellerDetailsRes.thirdPartyOriginationUPBPercent
          : '-'
        : 'null';
      this.waCombinedLTV = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.waCombinedLTV)
          ? this.disclosureSellerDetailsRes.waCombinedLTV
          : '-'
        : 'null';
      this.waOriginalLoanTerm = !isNullOrUndefined(this.disclosureSellerDetailsRes)
        ? !isNullOrUndefined(this.disclosureSellerDetailsRes.waOriginalLoanTerm)
          ? this.disclosureSellerDetailsRes.waOriginalLoanTerm
          : '-'
        : 'null';

      this.waBorrowerCreditScore = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waBorrowerCreditScore)
          ? this.disclosureWaDetailsRes.waBorrowerCreditScore
          : '-'
        : 'null';
      this.waInterestRate = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waInterestRate)
          ? this.disclosureWaDetailsRes.waInterestRate
          : '-'
        : 'null';
      this.waLoanAge = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waLoanAge)
          ? this.disclosureWaDetailsRes.waLoanAge
          : '-'
        : 'null';
      this.waLoanToValue = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waLoanToValue)
          ? this.disclosureWaDetailsRes.waLoanToValue
          : '-'
        : 'null';
      this.loanCount = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.loanCount)
          ? this.disclosureWaDetailsRes.loanCount
          : '-'
        : 'null';
      this.waMortgageLoanAmount = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waMortgageLoanAmount)
          ? this.disclosureWaDetailsRes.waMortgageLoanAmount
          : '-'
        : 'null';
      this.waNetInterestRate = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waNetInterestRate)
          ? this.disclosureWaDetailsRes.waNetInterestRate
          : '-'
        : 'null';
      this.waRemainingMonthsToMaturity = !isNullOrUndefined(this.disclosureWaDetailsRes)
        ? !isNullOrUndefined(this.disclosureWaDetailsRes.waRemainingMonthsToMaturity)
          ? this.disclosureWaDetailsRes.waRemainingMonthsToMaturity
          : '-'
        : 'null';
    }

    this.disclosureDetailsError();
  }

  public disclosureSelleDetails(sellerDetails: any): any {
    sellerDetails = this.passDataService.getDisclosureSellerDetailsRes();

    this.avgCurrentLoanSize = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.avgCurrentLoanSize)
        ? sellerDetails.avgCurrentLoanSize
        : '-'
      : 'null';
    this.avgMortgageLoanAmount = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.avgMortgageLoanAmount)
        ? sellerDetails.avgMortgageLoanAmount
        : '-'
      : 'null';
    this.currentSecurityUPB = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.currentSecurityUPB)
        ? sellerDetails.currentSecurityUPB
        : '-'
      : 'null';
    this.eligibleForResecuritization = !isNullOrUndefined(sellerDetails)
      ? sellerDetails.eligibleForResecuritization !== 'null'
        ? sellerDetails.eligibleForResecuritization
        : '-'
      : 'null';
    this.interestOnlySecurityIndicator = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.interestOnlySecurityIndicator)
        ? sellerDetails.interestOnlySecurityIndicator
        : '-'
      : 'null';
    this.longestMaturityDate = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.longestMaturityDate)
        ? sellerDetails.longestMaturityDate
        : '-'
      : 'null';
    this.maxLoanSize = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.maxLoanSize)
        ? sellerDetails.maxLoanSize
        : '-'
      : 'null';
    this.paymentDelayDays = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.paymentDelayDays)
        ? sellerDetails.paymentDelayDays
        : '-'
      : 'null';
    this.queryExecTime = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.queryExecTime)
        ? sellerDetails.queryExecTime
        : '-'
      : 'null';
    this.sellerName = !isNullOrUndefined(sellerDetails)
      ? sellerDetails.sellerName !== 'null'
        ? sellerDetails.sellerName
        : '-'
      : 'null';
    this.servicerName = !isNullOrUndefined(sellerDetails)
      ? sellerDetails.servicerName !== 'null'
        ? sellerDetails.servicerName
        : '-'
      : 'null';
    this.thirdPartyOriginationUPBPercent = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.thirdPartyOriginationUPBPercent)
        ? sellerDetails.thirdPartyOriginationUPBPercent
        : '-'
      : 'null';
    this.waCombinedLTV = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.waCombinedLTV)
        ? sellerDetails.waCombinedLTV
        : '-'
      : 'null';
    this.waOriginalLoanTerm = !isNullOrUndefined(sellerDetails)
      ? !isNullOrUndefined(sellerDetails.waOriginalLoanTerm)
        ? sellerDetails.waOriginalLoanTerm
        : '-'
      : 'null';
  }

  public disclosureWaDetails(waDetails: any): any {
    waDetails = this.passDataService.getDisclosureWaDetailsRes();

    this.waBorrowerCreditScore = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waBorrowerCreditScore)
        ? waDetails.waBorrowerCreditScore
        : '-'
      : 'null';
    this.waInterestRate = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waInterestRate)
        ? waDetails.waInterestRate
        : '-'
      : 'null';
    this.waLoanAge = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waLoanAge)
        ? waDetails.waLoanAge
        : '-'
      : 'null';
    this.waLoanToValue = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waLoanToValue)
        ? waDetails.waLoanToValue
        : '-'
      : 'null';
    this.loanCount = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.loanCount)
        ? waDetails.loanCount
        : '-'
      : 'null';
    this.waMortgageLoanAmount = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waMortgageLoanAmount)
        ? waDetails.waMortgageLoanAmount
        : '-'
      : 'null';
    this.waNetInterestRate = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waNetInterestRate)
        ? waDetails.waNetInterestRate
        : '-'
      : 'null';
    this.waRemainingMonthsToMaturity = !isNullOrUndefined(waDetails)
      ? !isNullOrUndefined(waDetails.waRemainingMonthsToMaturity)
        ? waDetails.waRemainingMonthsToMaturity
        : '-'
      : 'null';
  }

  public disclosureDetailsError(): any {
    if (
      isNullOrUndefined(this.disclosureSellerDetailsRes) &&
      this.passDataService.getAnalyzerDetailsErrorIconVal() === 'showSellerError'
    ) {
      this.avgCurrentLoanSizeError = true;
      this.avgMortgageLoanAmountError = true;
      this.currentSecurityUPBError = true;
      this.eligibleForResecuritizationError = true;
      this.interestOnlySecurityIndicatorError = true;
      this.waOriginalLoanTermError = true;
      this.longestMaturityDateError = true;
      this.maxLoanSizeError = true;
      this.paymentDelayDaysError = true;
      this.queryExecTimeError = true;
      this.sellerNameError = true;
      this.servicerNameError = true;
      this.thirdPartyOriginationUPBPercentError = true;
      this.waCombinedLTVError = true;
      this.showErrorBanner = true;
      this.showBannerErrorMsg = StringConstants.ANALYZER_DETAILS_ERROR_BANNER_MESSAGE;
    }

    if (
      isNullOrUndefined(this.disclosureWaDetailsRes) &&
      this.passDataService.getAnalyzerDetailsErrorIconVal() === 'showWaError'
    ) {
      this.waBorrowerCreditScoreError = true;
      this.waInterestRateError = true;
      this.waLoanAgeError = true;
      this.waLoanToValueError = true;
      this.waMortgageLoanAmountError = true;
      this.waNetInterestRateError = true;
      this.waRemainingMonthsToMaturityError = true;
      this.loanCountError = true;
      this.showErrorBanner = true;
      this.showBannerErrorMsg = StringConstants.ANALYZER_DETAILS_ERROR_BANNER_MESSAGE;
    }
  }

  public handleDisclosureWaDetailsError(error: any): any {
    this.waBorrowerCreditScoreError = error === 'waDetailsError' ? true : false;
    this.waInterestRateError = error === 'waDetailsError' ? true : false;
    this.waLoanAgeError = error === 'waDetailsError' ? true : false;
    this.waLoanToValueError = error === 'waDetailsError' ? true : false;
    this.waMortgageLoanAmountError = error === 'waDetailsError' ? true : false;
    this.waNetInterestRateError = error === 'waDetailsError' ? true : false;
    this.waRemainingMonthsToMaturityError = error === 'waDetailsError' ? true : false;
    this.loanCountError = error === 'waDetailsError' ? true : false;
    this.showErrorBanner = error === 'waDetailsError' ? true : false;
    this.showBannerErrorMsg =
      error !== 'details' ? StringConstants.ANALYZER_DETAILS_ERROR_BANNER_MESSAGE : '';
    if (error !== 'details') {
      this.passDataService.setAnalyzerDetailsErrorIconVal('showWaError');
    }
  }

  public handleDisclosureSellerDetailsError(error: any): any {
    this.avgCurrentLoanSizeError = error === 'sellerDetailsError' ? true : false;
    this.avgMortgageLoanAmountError = error === 'sellerDetailsError' ? true : false;
    this.currentSecurityUPBError = error === 'sellerDetailsError' ? true : false;
    this.eligibleForResecuritizationError = error === 'sellerDetailsError' ? true : false;
    this.interestOnlySecurityIndicatorError = error === 'sellerDetailsError' ? true : false;
    this.waOriginalLoanTermError = error === 'sellerDetailsError' ? true : false;
    this.longestMaturityDateError = error === 'sellerDetailsError' ? true : false;
    this.maxLoanSizeError = error === 'sellerDetailsError' ? true : false;
    this.paymentDelayDaysError = error === 'sellerDetailsError' ? true : false;
    this.queryExecTimeError = error === 'sellerDetailsError' ? true : false;
    this.sellerNameError = error === 'sellerDetailsError' ? true : false;
    this.servicerNameError = error === 'sellerDetailsError' ? true : false;
    this.thirdPartyOriginationUPBPercentError = error === 'sellerDetailsError' ? true : false;
    this.waCombinedLTVError = error === 'sellerDetailsError' ? true : false;
    this.showErrorBanner = error === 'sellerDetailsError' ? true : false;
    this.showBannerErrorMsg =
      error !== 'details' ? StringConstants.ANALYZER_DETAILS_ERROR_BANNER_MESSAGE : '';
    if (error !== 'details') {
      this.passDataService.setAnalyzerDetailsErrorIconVal('showSellerError');
    }
  }

  public resetDetailsAttributes(): void {
    this.avgCurrentLoanSize = null;
    this.avgMortgageLoanAmount = null;
    this.currentSecurityUPB = null;
    this.eligibleForResecuritization = null;
    this.interestOnlySecurityIndicator = null;
    this.loanCount = null;
    this.longestMaturityDate = null;
    this.maxLoanSize = null;
    this.paymentDelayDays = null;
    this.queryExecTime = null;
    this.sellerName = null;
    this.servicerName = null;
    this.thirdPartyOriginationUPBPercent = null;
    this.waBorrowerCreditScore = null;
    this.waCombinedLTV = null;
    this.waInterestRate = null;
    this.waLoanAge = null;
    this.waLoanToValue = null;
    this.waMortgageLoanAmount = null;
    this.waNetInterestRate = null;
    this.waOriginalLoanTerm = null;
    this.waRemainingMonthsToMaturity = null;

    this.avgCurrentLoanSizeError = false;
    this.avgMortgageLoanAmountError = false;
    this.currentSecurityUPBError = false;
    this.eligibleForResecuritizationError = false;
    this.interestOnlySecurityIndicatorError = false;
    this.loanCountError = false;
    this.longestMaturityDateError = false;
    this.maxLoanSizeError = false;
    this.paymentDelayDaysError = false;
    this.queryExecTimeError = false;
    this.sellerNameError = false;
    this.servicerNameError = false;
    this.thirdPartyOriginationUPBPercentError = false;
    this.waBorrowerCreditScoreError = false;
    this.waCombinedLTVError = false;
    this.waInterestRateError = false;
    this.waLoanAgeError = false;
    this.waLoanToValueError = false;
    this.waMortgageLoanAmountError = false;
    this.waNetInterestRateError = false;
    this.waOriginalLoanTermError = false;
    this.waRemainingMonthsToMaturityError = false;
  }

  public closeMessageBanner(): void {
    this.showErrorBanner = false;
  }

  public checkAnalytics(): void {
    const analyticsTab: any = {};
    analyticsTab.user = this.userService.getUserName();
    analyticsTab.tabName = 'disclosureDetails';
    analyticsTab.tempMega = this.passDataService.getTempMega();

    this.disclosureAnalyticsService.checkDisclosureAnalytics(analyticsTab).subscribe({
      next: (data) => this.handleDisclosureAnalyticsSuccess(data),
      error: (error) => this.handleDisclosureAnalyticsServiceFail(error),
    });
  }

  public handleDisclosureAnalyticsSuccess(_res: any) {
    this.cdr.markForCheck();
  }

  public handleDisclosureAnalyticsServiceFail(_error: any): void {
    this.cdr.markForCheck();
  }
}
